// extracted by mini-css-extract-plugin
export default {"container1":"container1___CLXAf","nav":"nav___wdEQk","left":"left___CCG90","other":"other___eAGtv","block":"block___pmOEy","footer":"footer___owegW"};